var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.16 14.847h-.087c-2.96 0-4.387-1.167-4.633-3.78a.501.501 0 1 1 1-.094c.193 2.094 1.18 2.874 3.64 2.874h.086c2.714 0 3.674-.96 3.674-3.674V5.827c0-2.714-.96-3.674-3.674-3.674h-.086c-2.474 0-3.46.794-3.64 2.927a.506.506 0 0 1-1.007-.087c.227-2.653 1.66-3.84 4.64-3.84h.087c3.273 0 4.673 1.4 4.673 4.674v4.346c0 3.274-1.4 4.674-4.673 4.674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5H2.413a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H10c.273 0 .5.227.5.5s-.227.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 10.733a.5.5 0 0 1-.353-.146L1.313 8.353a.503.503 0 0 1 0-.706l2.234-2.234a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707L2.373 8l1.88 1.88a.503.503 0 0 1 0 .707.48.48 0 0 1-.353.146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.84201223470369cf9ef3a534410d03a8.svg";
export { ForwardRef as ReactComponent };